import { SERVICE_EVENT } from '@/services';
import { HELPERS } from '@/utils';
import * as TYPES_EVENT from './event.types';

const getEventDetail = (slug) => {
  return async (dispatch) => {
    dispatch({ type: TYPES_EVENT.GET_EVENT_DETAIL_LOADING, loading: true });

    try {
      const response = await SERVICE_EVENT.getEventDetailData(slug);

      if (response.payload?.success === true && response.payload?.data) {
        dispatch({
          type: TYPES_EVENT.GET_EVENT_DETAIL_DATA,
          payload: response.payload.data,
        });
      } else if (response.success === false && response.error) {
        const statusCode = response.error?.status || response.error?.response?.status || null;
        const errorMessage =
          response.error?.message || response.payload?.message || 'Failed to load event details.';

        const errorPayload = {
          message: errorMessage,
          status: statusCode,
        };
        HELPERS.showNotificationServiceError(errorPayload);
        dispatch({
          type: TYPES_EVENT.GET_EVENT_DETAIL_ERROR,
          error: errorPayload,
        });
      } else {
        const errorPayload = {
          message: 'Received an unexpected response structure from the service function.',
          status: null,
        };
        HELPERS.showNotificationServiceError(errorPayload);
        dispatch({
          type: TYPES_EVENT.GET_EVENT_DETAIL_ERROR,
          error: errorPayload,
        });
      }
    } catch (error) {
      let errorPayload = {
        message: 'An unknown network or setup error occurred.',
        status: null,
      };
      if (error.response) {
        errorPayload = {
          message: error.response.data?.message || error.message,
          status: error.response.status,
          data: error.response.data,
        };
      } else if (error.request) {
        errorPayload.message = 'No response received from server.';
      } else {
        errorPayload.message = error.message;
      }

      HELPERS.showNotificationServiceError(errorPayload);
      dispatch({
        type: TYPES_EVENT.GET_EVENT_DETAIL_ERROR,
        error: errorPayload,
      });
    }
  };
};

const getEventCategories = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: TYPES_EVENT.GET_EVENT_CATEGORIES_LOADING,
        loading: true,
      });

      const response = await SERVICE_EVENT.getEventCategories();

      if (!response.success || response.error) {
        HELPERS.showNotificationServiceError(response.error);
      } else {
        dispatch({
          type: TYPES_EVENT.GET_EVENT_CATEGORIES_DATA,
          payload: response.payload,
        });
      }
    } catch (error) {
      HELPERS.showNotificationServiceError(error);
    } finally {
      dispatch({
        type: TYPES_EVENT.GET_EVENT_CATEGORIES_LOADING,
        loading: false,
      });
    }
  };
};

const getEventsList = (filters = {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: TYPES_EVENT.GET_EVENTS_LIST_LOADING, loading: true });

      const response = await SERVICE_EVENT.getEventsList(filters);

      if (!response.success || response.error) {
        HELPERS.showNotificationServiceError(response.error);
      } else {
        dispatch({
          type: TYPES_EVENT.GET_EVENTS_LIST_DATA,
          payload: {
            data: response.data || [],
            pagination: response.pagination || {},
          },
        });
      }
    } catch (error) {
      HELPERS.showNotificationServiceError(error);
    } finally {
      dispatch({ type: TYPES_EVENT.GET_EVENTS_LIST_LOADING, loading: false });
    }
  };
};

const getTicket = (slug) => {
  return async (dispatch) => {
    dispatch({ type: TYPES_EVENT.GET_TICKET_LOADING, loading: true });
    try {
      const res = await SERVICE_EVENT.getTicket(slug);
      if (res.error) {
        HELPERS.showNotificationServiceError(res.error);
      } else {
        dispatch({ type: TYPES_EVENT.GET_TICKET_DATA, payload: res.payload });
      }
    } catch (error) {
      HELPERS.showNotificationServiceError(error);
    }
  };
};

export const ACTION_EVENT = {
  getEventDetail,
  getTicket,
  getEventCategories,
  getEventsList,
};
